import type { RequestInterface } from '~/common/types';

export class IntervalsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/calendar/intervals';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class TemplatesRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/calendar/templates';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class UpdateTemplateRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    id,
    templateData,
  }: {
    token: string;
    id: string;
    templateData: any;
  }) {
    this.path = `/api/v1/calendar/update/${id}/template`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...templateData,
    };
  }
}
export class AddTemplateRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/calendar/store/template';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, template }: { token: string; template: any }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...template,
    };
  }
}
export class CreateEventRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/calendar/events';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, event }: { token: string; event: any }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...event,
    };
  }
}
export class DeleteTemplateRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({ token, templateID }: { token: string; templateID: string }) {
    this.path = `/api/v1/calendar/template/${templateID}/delete`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };

    this.params = {
      templateID,
    };
  }
}
export class SingleTemplateRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({ token, templateID }: { token: string; templateID: string }) {
    this.path = `/api/v1/calendar/${templateID}/template`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}
export class SubCategoriesRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/calendar/subcategories';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({ token, categoryID }: { token: string; categoryID: string }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };

    this.params = {
      categoryID,
    };
  }
}
export class GetEventsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/calendar/events';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    fromDate,
    toDate,
    params,
  }: {
    token: string;
    fromDate: string;
    toDate: string;
    params?: { include?: string };
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };

    this.params = {
      fromDate,
      toDate,
      ...params,
    };
  }
}
export class GetEventDetailRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    id,
    params,
  }: {
    token: string;
    id: string;
    params?: { include?: string };
  }) {
    this.path = `/api/v1/calendar/${id}/event`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };

    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class deleteEventRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data?: Record<string, any>;

  constructor({
    token,
    id,
    updateType,
  }: {
    token: string;
    id: string;
    updateType: string;
  }) {
    this.path = `/api/v1/calendar/event/${id}/delete`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      updateType: updateType,
    };
  }
}

export class updateEventRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    eventID,
    event,
  }: {
    token: string;
    eventID: string;
    event: any;
  }) {
    this.path = `/api/v1/calendar/update/${eventID}/events`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };

    this.data = {
      ...event,
    };
  }
}
export class AllLocationRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/calendar/locations/all';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class GetLocationDetailRequest implements RequestInterface {
  method = 'get'
  path : string
  headers: Record<string, any>
  params?: Record<string, any>
  constructor ({
    token,
    id    
  }: {
    token: string
    id: string    
  }) { 
    this.path = `/api/v1/calendar/${id}/locations` 
    this.headers = {
      authorization: `Bearer ${token}`
    }   
    this.params = {
      id
    } 
  } 
}
export class AddLocationRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/calendar/locations/store';
  headers: Record<string, any>
  data: Record<string, any>;
  constructor({ token, name }: { token: string; name: string}) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      name : name,
    };
  }   
}
export class UpdateLocationRequest implements RequestInterface {
  method = 'patch';
  path : string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, id, name }: { token: string; id : string, name: string }) {
  this.path = `/api/v1/calendar/locations/${id}/update`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      name : name,
    };
  }
}
export class DeleteLocationRequest implements RequestInterface {
  method = 'delete';
  path : string;
  headers: Record<string, any>;
  params: Record<string, any>;   
  constructor({
    token,
    id,
  }: {
    token: string;
    id: string;
  }) {
    this.path = `/api/v1/calendar/locations/${id}/delete`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.params = {
      id,
    };
  } 
}

export class AllCategoriesRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/calendar/categories/all';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
export class AddCategoryRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/calendar/categories/store';
  headers: Record<string, any>;
  data: Record<string, any>;
  constructor({
    token,
    name,
    id,
  }: {
    token: string;
    name: string;
    id: string | null;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      name: name,
      parentID: id,
    };
  }
}
export class UpdateCategoryRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    id,
    name,
  }: {
    token: string;
    id: string;
    name: string;
  }) {
    this.path = `/api/v1/calendar/update/${id}/categories`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      name: name,
    };
  }
}

export class UpdateSubCategoryRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({
    token,
    id,
    name,
    parentID,
  }: {
    token: string;
    id: string;
    name: string;
    parentID: string;
  }) {
    this.path = `/api/v1/calendar/update/${id}/categories`;

    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      name: name,
      parentID: parentID,
    };
  }
}
export class DeleteCategoryRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;
  params: Record<string, any>;
  constructor({ token, id }: { token: string; id: string }) {
    this.path = `/api/v1/calendar/categories/${id}/delete`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.params = {
      id,
    };
  }
}
export class GetCategoryDetailRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;
  constructor({ token, id }: { token: string; id: string }) {
    this.path = `/api/v1/calendar/${id}/categories`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.params = {
      id,
    };
  }
}
export class CompleteEventRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/calendar/events/complete';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, event }: { token: string; event: any }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...event,
    };
  }
}
